import React from 'react';

import { Icon, IconNames } from '../Icon';

interface AbsenceTypeIconProps {
  variant?:
    | 'vacation'
    | 'maternity_leave'
    | 'student_leave'
    | 'business_trip'
    | 'sick_leave';
}

export const AbsenceTypeIcon = ({ variant }: AbsenceTypeIconProps) => {
  let iconName: IconNames;

  switch (variant) {
    case 'vacation':
      iconName = 'vkhrtek_vacation';
      break;
    case 'maternity_leave':
      iconName = 'vkhrtek_maternity_leave';
      break;
    case 'student_leave':
      iconName = 'education_outline';
      break;
    case 'business_trip':
      iconName = 'place_outline';
      break;
    case 'sick_leave':
      iconName = 'vkhrtek_medical';
      break;
    default:
      iconName = 'vkhrtek_absence';
  }

  return <Icon name={iconName} size="14" />;
};
